import type { EmailConversationLinkRequest } from "@features/communications/types";
import type { MessageFormat } from "./messageDocument";

export type ConversationLinkSelection = {
	ids: string[];
	typeId: string | null;
	classId: string | null;
	requiresClass: boolean;
	title: string | null;
	message: string;
	messageFormat?: MessageFormat;
	messageHasContent?: boolean;
};

export type ConversationLinkTarget = Omit<
	EmailConversationLinkRequest,
	"studentNumber"
>;

export function emailConversationTarget(
	mode: "existing" | "new",
	value: ConversationLinkSelection,
	subject: string,
): ConversationLinkTarget {
	const message =
		value.messageHasContent === false
			? undefined
			: value.message.trim() || undefined;
	const format =
		message && value.messageFormat
			? { messageFormat: value.messageFormat }
			: {};
	if (mode === "existing") {
		if (!value.ids.length)
			throw new Error("Select at least one conversation before sending.");
		return { conversationIds: value.ids.map(Number), message, ...format };
	}
	const title = (value.title ?? subject).trim();
	if (!value.typeId || !title || (value.requiresClass && !value.classId))
		throw new Error(
			"Choose a conversation type, title, and class where required before sending.",
		);
	return {
		message,
		...format,
		newConversation: {
			typeCfCId: Number(value.typeId),
			studentClassId: value.requiresClass ? Number(value.classId) : null,
			title,
		},
	};
}
